import { CrossdockInboundQuote } from "common/clients/crossdock/CrossdockInboundQuote/CrossdockInboundQuote";
import { createActionCreator } from "common/ReduxUtils";
import { CrossdockActionTypes } from "../../CrossdockActionTypes";

export const setCrossdockInboundQuote = createActionCreator<CrossdockInboundQuote>(
  CrossdockActionTypes.SET_CROSSDOCK_INBOUND_QUOTE,
  "quote"
);
